import styled from 'styled-components'

import { toRem } from 'styles'

export const Svg = styled.svg.attrs({
	width: toRem(48),
	height: toRem(48),
})`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
`
